import React, { useEffect, useRef } from "react";

const TurnstileWidget = ({ onVerify, onExpire, onError }) => {
    const containerRef = useRef(null);
    const widgetIdRef = useRef(null);

    useEffect(() => {
        if (!window.turnstile || !containerRef.current) return;
        if (widgetIdRef.current !== null) return;

        widgetIdRef.current = window.turnstile.render(containerRef.current, {
            sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
            callback: (token) => {
                onVerify?.(token);
            },
            "expired-callback": () => {
                onExpire?.();
            },
            "error-callback": () => {
                onError?.();
            },
        });

        return () => {
            if (window.turnstile && widgetIdRef.current !== null) {
                window.turnstile.remove(widgetIdRef.current);
                widgetIdRef.current = null;
            }
        };
    }, []);

    return <div ref={containerRef} />;
};

export default TurnstileWidget;